import React from "react";
import { Link } from "react-router-dom";

// Sri Durga Foods logos — pre-processed to have TRANSPARENT backgrounds so
// they blend cleanly against any surface (header, footer, ivory, white). The
// previous mix-blend-multiply hack sometimes rendered a visible "white box"
// on certain browsers when the source PNG's background wasn't perfectly
// neutral — that's fixed by making near-white pixels alpha=0 during build.
const LOGO_SRCS = {
  header: "/sdf-logo-header.png",
  footer: "/sdf-logo-footer.png",
};

// Size presets (aspect ratio of the crest is ~1:0.8). Header uses `md` (or
// `sm` when scrolled) — both are paired with a negative vertical margin in
// the header so the logo appears larger without changing the header height.
const SIZES = {
  sm: "h-14 md:h-16",
  md: "h-16 md:h-20",
  lg: "h-20 md:h-24",
  xl: "h-32 md:h-44",
};

export default function Logo({ size = "md", className = "", asLink = true, variant = "header" }) {
  const cls = `${SIZES[size] || SIZES.md} w-auto object-contain select-none pointer-events-none`;
  const img = (
    <img
      src={LOGO_SRCS[variant] || LOGO_SRCS.header}
      alt="Sri Durga Foods"
      className={cls}
      draggable={false}
    />
  );
  if (!asLink) return <span className={`inline-flex ${className}`}>{img}</span>;
  return (
    <Link to="/" data-testid="sri-durga-logo" aria-label="Sri Durga Foods" className={`inline-flex ${className}`}>
      {img}
    </Link>
  );
}
